import React from 'react';

import { Ellipsis, StandardDateTime } from 'ui/base';

import Item from 'ui/base/ImportModal/Item';

/**
 * @type {React.FC<{
 *   dealerId: string;
 *   value: string[];
 *   onChange: React.Dispatch<React.SetStateAction<string[]>>;
 * }import('modules/tireScan/types').TireScan>}
 * */
const TscanListItem = ({ id: tireScanId, registration, createdOn, vin, dealerId, value, onChange }) => {
  const selected = value.includes(tireScanId);

  const handleChangeOnClick = React.useCallback(() => {
    const newValue = !selected ? [...value, tireScanId] : value.filter((id) => tireScanId !== id);
    onChange(newValue);
  }, [onChange, selected, tireScanId, value]);

  return (
    <Item selected={selected} onClick={handleChangeOnClick} data-cy={`scan-${tireScanId}`}>
      <div className="d-flex flex-column justify-content-left align-items-start">
        <Ellipsis className="font-weight-bold text-break-all" clamp={1}>{registration ?? vin}</Ellipsis>
      </div>
      {createdOn && (
        <div className="d-flex flex-column justify-content-left align-items-end text-right flex-shrink-0">
          <StandardDateTime value={createdOn} dealerId={dealerId} />
        </div>
      )}
    </Item>
  );
};

export default TscanListItem;
